import ImageEvaluationItemList from "../ImageEvaluationItemList/imageEvaluationItemList";
import { useEffect, useState } from "react";
import { appAxiosInstance } from "../../../api";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { PaginationControl } from "react-bootstrap-pagination-control";
import s from './imageEvaluationList.module.css';
import { IImageEvaluation, IImageEvaluationRequestParams, IImageEvaluationResponse } from '../types';
import { Loader } from "../../../components/Loader/loader";

export default function ImageEvaluationList() {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [allItems, setAllItems] = useState(0);
    const [dateBegin, setDateBegin] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [imageEvaluation, setImageEvaluation] = useState<IImageEvaluation[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getImageEvaluation = async () => {

        try {
            setIsLoading(true);
            const params: IImageEvaluationRequestParams = {
                currentPage: currentPage,
                itemsPerPage: itemsPerPage,
                dateBegin: dateBegin || null,
                dateEnd: dateEnd || null
            }

            const imageEvaluationResponse = await appAxiosInstance.get<IImageEvaluationResponse>('mobile/assistant', { params });
            const imageEvaluationList = imageEvaluationResponse.data;

            if (imageEvaluationList?.feedbackRecords) {
                const sanitizedData = imageEvaluationList.feedbackRecords.map(data => ({
                    ...data,
                    fashionComposition: data.fashionComposition || {}
                }));
                
                setImageEvaluation(sanitizedData);
                setAllItems(imageEvaluationList.countRecords || 0);
            } else {
                setImageEvaluation([]);
                setAllItems(0);
            }
        } catch (error) {
            toast.error(`Ошибка при получении оценок образов`);
            setImageEvaluation([]);
            setAllItems(0);
        } finally {
            setIsLoading(false);
        }
    };

    const paginate = (pageNumbers: number) => {
        setCurrentPage(pageNumbers);
    }

    const find = () => {
        getImageEvaluation();
    }

    const cleanForm = () => {
        setDateBegin('');
        setDateEnd('');
    }

    useEffect(() => {
        getImageEvaluation();
    }, [currentPage, dateBegin, dateEnd]);

    return (

        <div>
            <div className={s.filterBlock}>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата начала</div>
                    <input
                        value={dateBegin}
                        type="date"
                        onChange={e => setDateBegin(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата окончания</div>
                    <input
                        value={dateEnd}
                        type="date"
                        onChange={e => setDateEnd(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <Button type="button" className={s.searchFormButton} onClick={find}>Поиск</Button>
                <Button type="button" className={s.searchFormButton} onClick={cleanForm}>Сбросить фильтр</Button>
            </div>

            {isLoading ? (
                <div className={s.loadingContainer}>
                    <Loader/>
                </div>
                ) : (
                <div>
                    {imageEvaluation && imageEvaluation.length > 0 ? (
                    imageEvaluation.map((evaluation, index) => (
                        <ImageEvaluationItemList key={`image-${index}`} evaluation={evaluation} />
                    ))
                    ) : (
                    <div className={s.emptyState}>
                        <h3 className={s.emptyStateTitle}>Оценки не найдены</h3>
                    </div>
                    )}
                </div>
            )}

            <PaginationControl
                page={currentPage}
                between={4}
                total={allItems}
                limit={itemsPerPage}
                changePage={(page) => {
                    paginate(page)
                }}
                ellipsis={1}
            />
        </div>
    );
}